// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../admin/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.date-options.with-picker[data-v-833bec38] {\n\tmargin-right: 1em;\n}\n", ""]);
// Exports
module.exports = exports;
